import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AppConfig from "../../config";
import { TaskAltOutlined } from "@mui/icons-material";

const VerticalTabs = ({ steps, selectedTab, handleTabChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [visitedTabs, setVisitedTabs] = useState([]);

  useEffect(() => {
    if (!visitedTabs.includes(selectedTab)) {
      setVisitedTabs((prev) => [...prev, selectedTab]);
    }
  }, [selectedTab, visitedTabs]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        height: isMobile ? "auto" : "100%",
        width: "100%",
        alignItems: "flex-start",
      }}
    >
      <Tabs
        orientation={isMobile ? "horizontal" : "vertical"}
        variant="scrollable"
        value={selectedTab}
        onChange={handleTabChange}
        sx={{
          borderRight: isMobile ? "none" : "none",
          borderBottom: isMobile ? 1 : "none",
          width: "100%",
          height: "100%",
        }}
        TabIndicatorProps={{
          sx: {
            left: 0,
            backgroundColor: "#b41660",
            width: "4px",
            height: isMobile ? "4px" : "100%",
          },
        }}
        scrollButtons={isMobile ? "auto" : false}
        allowScrollButtonsMobile
      >
        {steps.map((step, index) => (
          <Tab
            key={index}
            label={
              <Box
                style={{
                  color:
                    selectedTab === index
                      ? AppConfig.colorPalette.primary.main
                      : "",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 8,
                  height: "100%",
                  width: "100%",
                }}
              >
                <Box>{step}</Box>
                {step == "Activities" && (
                  <Box>
                    <TaskAltOutlined />
                  </Box>
                )}
              </Box>
            }
            sx={{
              border: step == "Activities" ? "4px dotted" : "none",
              borderImageSlice: 1,
              borderImageSource: {
                md: "linear-gradient(to right, #b41660,#f7a2cc)",
                xs: "linear-gradient(to top, #b41660,#f7a2cc)",
              },
              color:
                selectedTab === index
                  ? AppConfig.colorPalette.primary.main
                  : // : visitedTabs.includes(index)
                    // ? AppConfig.colorPalette.primary.main
                    AppConfig.colorPalette.primary.main,
              fontWeight: selectedTab === index ? "bold" : "normal",
              backgroundColor:
                selectedTab === index
                  ? AppConfig.colorPalette.primary.light
                  : "",
              width: isMobile ? "18vw" : "13vw",
              height: "60px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default VerticalTabs;
